import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { AlertModal, AlertModalCloseButton, AlertModalDescription, AlertModalTitle } from "@air/primitive-alert-modal";
import { Button } from "@air/primitive-button";
import { useRef } from "react";
export const ConfirmationModal = (param)=>{
    let { ctaPrimaryText = "Confirm", ctaSecondaryText = "Cancel", description, children, id, isDangerous, isDisabled, isLoading, onDismiss, onConfirm, title, ...restOfProps } = param;
    const leastDestructiveRef = useRef(null);
    return /*#__PURE__*/ _jsxs(AlertModal, {
        "data-id": id,
        "data-testid": "CONFIRMATION_MODAL",
        leastDestructiveRef: leastDestructiveRef,
        onDismiss: onDismiss,
        ...restOfProps,
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "mb-3 flex justify-between",
                children: [
                    /*#__PURE__*/ _jsx(AlertModalTitle, {
                        "data-testid": "CONFIRMATION_MODAL_TITLE",
                        children: title
                    }),
                    /*#__PURE__*/ _jsx(AlertModalCloseButton, {
                        "data-testid": "CONFIRMATION_MODAL_CLOSE",
                        className: "shrink-0",
                        onClick: onDismiss
                    })
                ]
            }),
            !!description && /*#__PURE__*/ _jsx(AlertModalDescription, {
                className: "pb-2 pt-1",
                children: description
            }),
            children,
            /*#__PURE__*/ _jsxs("div", {
                className: "-mx-6 -mb-6 flex justify-end gap-3 px-6 py-4",
                children: [
                    /*#__PURE__*/ _jsx(Button, {
                        appearance: "ghost",
                        color: "grey",
                        "data-testid": "CONFIRMATION_MODAL_SECONDARY_CTA",
                        disabled: isLoading,
                        onClick: onDismiss,
                        ref: leastDestructiveRef,
                        size: "large",
                        children: ctaSecondaryText
                    }),
                    /*#__PURE__*/ _jsx(Button, {
                        appearance: "filled",
                        color: isDangerous ? "red" : "blue",
                        "data-testid": "CONFIRMATION_MODAL_PRIMARY_CTA",
                        disabled: isDisabled,
                        isLoading: isLoading,
                        onClick: onConfirm,
                        size: "large",
                        children: ctaPrimaryText
                    })
                ]
            })
        ]
    });
};
